import { MAX_LEVEL } from "./constants.js";

/**
 * RuneScape 1-99 experience curve.
 *
 * XP required to *reach* `level` (cumulative from level 1).
 * Level 1 = 0 XP; level 99 ≈ 13,034,431.
 */
export function xpToNextLevelPoint(level: number): number {
  let total = 0;
  for (let n = 1; n < level; n++) {
    total += Math.floor(n + 300 * Math.pow(2, n / 7)) / 4;
  }
  return Math.floor(total);
}

export const XP_TABLE: readonly number[] = (() => {
  const table: number[] = [0];
  for (let level = 1; level <= MAX_LEVEL; level++) {
    table[level] = xpToNextLevelPoint(level);
  }
  return table;
})();

export function levelFromXp(xp: number): number {
  let lo = 1;
  let hi = MAX_LEVEL;
  while (lo < hi) {
    const mid = Math.ceil((lo + hi + 1) / 2);
    const need = XP_TABLE[mid] ?? Number.POSITIVE_INFINITY;
    if (xp >= need) {
      lo = mid;
    } else {
      hi = mid - 1;
    }
  }
  return lo;
}

export function xpForLevel(level: number): number {
  const clamped = Math.min(MAX_LEVEL, Math.max(1, level));
  return XP_TABLE[clamped] ?? 0;
}

export function xpToNextLevel(xp: number): number {
  const level = levelFromXp(xp);
  if (level >= MAX_LEVEL) {
    return 0;
  }
  const next = XP_TABLE[level + 1] ?? xp;
  return Math.max(0, next - xp);
}
